import { ReCaptchaService } from './../services/re-captcha.service';
import {AfterViewInit, Component, EventEmitter, OnInit, Output} from '@angular/core';
import { Validators, FormBuilder } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { NzNotificationService } from 'ng-zorro-antd/notification';
import { environment } from 'src/environments/environment';
import {CaptchaService} from "../../authentication/services/captcha.service";

@Component({
  selector: 'app-captcha',
  templateUrl: './captcha.component.html',
  styleUrls: ['./captcha.component.scss']
})
export class CaptchaComponent implements OnInit,AfterViewInit  {

  isVisible: boolean = true;

  siteKey = environment.recaptcha.siteKey;

  recaptchaForm = this.fb.group({
    captcha: ['', Validators.required]
  });

  @Output() verifyStatus: EventEmitter<{success:boolean,message:string}> = new EventEmitter<{success:boolean,message:string}>();

  constructor(
    private notification: NzNotificationService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private fb: FormBuilder,
    private reCaptchaService: ReCaptchaService,
    private  captchaService : CaptchaService,
  ) { }

  ngOnInit(): void {
    this.captchaText = this.captchaService.captchaGenerator();
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      this.captchaText = this.captchaService.captchaGenerator();
    });
  }

  showModal(): void {
    this.isVisible = true;
  }

  handleCancel(): void {
    this.isVisible = false;
  }

  resolved(captchaResponse: string) {
   // console.log(`Resolved captcha with response: ${captchaResponse}`);
    this.verifyCaptcha(captchaResponse);
  }


  verifyCaptcha(captchaResponse: string) {
    this.reCaptchaService.verifyRecaptcha({ captchaResponse: captchaResponse })
      .subscribe(
        (res: any) => {
          if (res.success) {
            this.isVisible = false;
          } else {
            this.isVisible = true;;
          }

          this.verifyStatus.emit({success: res.success,message:res.message});
        },

        (err) => {
          this.notification.error("Error", "Something went wrong while verifying captcha");
        })

  }
  userInput: any;
  captchaError: boolean = false;
  captchaText: string;

  refreshCaptcha() {
    this.captchaText = this.captchaService.captchaGenerator();
    this.captchaError = false;
  }
  verify() {
    if (this.userInput === this.captchaText) {
      this.verifyStatus.emit({success: true,message:"Captcha Verified!"});
      this.isVisible = false;
    } else {
      this.notification.error(
        'Invalid!',
        'Please correct the CAPTCHA!'
      );
      this.captchaError = true;
    }
  }

}
